import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
type Props = {
  items: {
    q: string;
    a: string;
  }[];
  idPrefix?: string;
};
export function FaqAccordion({
  items,
  idPrefix = "faq"
}: Props) {
  const [open, setOpen] = useState<number | null>(0);
  return <ul className="divide-y divide-line border-y border-line" data-id="element-445" data-mp="1oj02uo82ybjt">
      {items.map((item, i) => {
      const isOpen = open === i;
      const id = `${idPrefix}-${i}`;
      return <li key={item.q} data-id="element-446" data-mp="vwffdyuq6jlj" data-mpi={i}>
            <h3 data-id="element-447" data-mp="vvnimkpe6fto">
              <button type="button" aria-expanded={isOpen} aria-controls={`${id}-panel`} id={`${id}-btn`} onClick={() => setOpen(isOpen ? null : i)} className="flex min-h-[64px] w-full items-center justify-between gap-6 py-5 text-left font-display text-[clamp(1.05rem,0.95rem+0.4vw,1.5rem)] font-medium tracking-tight hover:text-accent-soft" data-id="element-448" data-mp="vt9m07f2cvk0">
                {item.q}
                <PlusIcon aria-hidden className={`h-5 w-5 shrink-0 text-accent-soft transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} data-id="element-449" data-mp="1fne5wqloyfk2" />
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-450" data-mp="10zt4d14gsoe9">
              {isOpen && <motion.div id={`${id}-panel`} role="region" aria-labelledby={`${id}-btn`} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: "auto",
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-451" data-mp="10xf7qnu4z44l">
                  <p className="t-body max-w-[70ch] pb-6 text-muted" data-id="element-452" data-mp="2hcggdwmiz46e">{item.a}</p>
                </motion.div>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}